import React from "react";

export default function TFJS_Models() {
  return (
    <div>
      <h1>TFJS_Models</h1>
      <p>This is the TFJS_Models component.</p>
    </div>
  );
}
